import { createContext, PropsWithChildren, useContext } from 'react';
import { useEditTranslateController } from './controller';
import { EditTranslateContextParams } from './types';

export const EditTranslateContext = createContext<EditTranslateContextParams>({
  setIsEditing: function (next?: string): void {
    throw new Error('Function not implemented.');
  },
});

export function useEditTranslateContext() {
  return useContext(EditTranslateContext);
}

export function EditTranslateProvider({ children }: PropsWithChildren<{}>) {
  const value = useEditTranslateController();
  return (
    <EditTranslateContext.Provider value={value}>
      {children}
    </EditTranslateContext.Provider>
  );
}
